<div
  class="main-containor"
  [formGroup]="patientDetailAddInfo"
  class="p-6 pb-20"
>
  <div class="grid grid-cols-6 gap-2">
    <div class="col-span-6">
      <app-editor
        placeholder="History comments"
        customClass="!w-full"
        [maxLength]="2048"
        label="History"
        [errors]="patientDetailAddInfo.get('history')?.errors"
         [group]="'patient:medical_history'"
        [content]="
          patientDetailAddInfo.get('history')?.value
        "
        (contentChange)="onFieldChange($event, 'history')"
      ></app-editor>
      <app-custom-text-select
        [maxLength]="2048"
        [group]="'patient:medical_history'"
        label="Medical History"
        class="col-span-2"
        (textSelected)="onFieldAdd($event, 'history')" >

      </app-custom-text-select>
    </div>

    <div class="col-span-6">
      <app-editor
        placeholder="Medications comments"
        customClass="!w-full"
        [maxLength]="2048"
        label="Medications"
        [errors]="patientDetailAddInfo.get('medications')?.errors"
        [content]="
          patientDetailAddInfo.get('medications')?.value
        "
        (contentChange)="onFieldChange($event, 'medications')"
         [group]="'patient:known_medications'"
      ></app-editor>
      <app-custom-text-select
        [maxLength]="2048"
        [group]="'patient:known_medications'"
        label="Known Medications"
        class="col-span-2"
        (textSelected)="onFieldAdd($event, 'medications')" >

      </app-custom-text-select>
    </div>



    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Pregnant Y/N</mat-label>
      <mat-select formControlName="isPregnant">
        <ng-container>
          <mat-option *ngFor="let bool of boolChoose" [value]="bool.value">
            {{ bool.viewValue }}
          </mat-option>
        </ng-container>
      </mat-select>
      <mat-error>{{ "Required field" }}</mat-error>
    </mat-form-field>
     <mat-form-field *ngIf="patientDetailAddInfo.value.isPregnant" appearance="outline" class="col-span-2">
      <mat-label>Gestational Age</mat-label>
      <input matInput formControlName="gestationalAge" />
      <mat-error
        *ngIf="
          patientDetailAddInfo.get('gestationalAge')?.hasError('notNumber')
        "
      >
        Must be a valid number
      </mat-error>

      <!-- Out of range -->
      <mat-error
        *ngIf="patientDetailAddInfo.get('gestationalAge')?.hasError('range')"
      >
        Must be between 2 and 43
      </mat-error>
    </mat-form-field>



    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Smoker Y/N</mat-label>
      <mat-select formControlName="smoker">
        <ng-container>
          <mat-option *ngFor="let bool of boolChoose" [value]="bool.value">
            {{ bool.viewValue }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>



    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Medical condition</mat-label>
      <input matInput formControlName="medicalCondition" />
      <mat-error>{{ "Required field" }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Profession</mat-label>
      <input matInput formControlName="profession" />
    </mat-form-field>



    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Country of birth</mat-label>
      <input matInput formControlName="countryOfBirth" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Education</mat-label>
      <input matInput formControlName="education" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Income Level</mat-label>
      <input matInput  noNegativeInput formControlName="incomeLevel" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Medication groups</mat-label>
      <mat-select
        multiple
        [multiple]="true"
        formControlName="medicationGroups"
        name="medicationGroups"
      >
        <ng-container *ngFor="let a of ALL_MEDICATION_GROUPS_OPTIONS">
          <mat-option [value]="a.value">
            {{ a.viewValue }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Race</mat-label>
      <mat-select formControlName="race" name="race">
        <ng-container *ngFor="let a of ALL_RACE_OPTIONS">
          <mat-option [value]="a.value">
            {{ a.viewValue }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Alcohol</mat-label>
      <mat-select formControlName="alcohol" name="alcohol">
        <ng-container *ngFor="let a of ALL_ALCOHOL_OPTIONS">
          <mat-option [value]="a.value">
            {{ a.viewValue }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Caffeine</mat-label>
      <mat-select formControlName="caffeine" name="caffeine">
        <ng-container *ngFor="let a of ALL_CAFFEINE_OPTIONS">
          <mat-option [value]="a.value">
            {{ a.viewValue }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Exercise</mat-label>
      <mat-select formControlName="exercise" name="exercise">
        <ng-container *ngFor="let a of ALL_EXERCISE_OPTIONS">
          <mat-option [value]="a.value">
            {{ a.viewValue }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Stress level</mat-label>
      <mat-select formControlName="stressLevel" name="stressLevel">
        <ng-container *ngFor="let a of ALL_STRESS_LEVEL_OPTIONS">
          <mat-option [value]="a.value">
            {{ a.viewValue }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Usual hours of sleep</mat-label>
      <input matInput formControlName="generic_1" />
      <mat-error>{{ "Required field" }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Diagnosed sleep disorder</mat-label>
      <mat-select formControlName="sleepDisorder">
        <ng-container>
          <mat-option *ngFor="let bool of boolChoose" [value]="bool.value">
            {{ bool.viewValue }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="patientDetailAddInfo.value.sleepDisorder" appearance="outline" class="col-span-2">
      <mat-label>Known disorder</mat-label>
      <input matInput formControlName="generic_2" />
      <mat-error>{{ "Required field" }}</mat-error>
    </mat-form-field>




     <app-height-input
        class="col-span-2"
        label="Neck Size"
        [inchesOnly]="true"
        [heightInCm]="patientDetailAddInfo.controls['neckSize'].value"
        (heightChange)="onNeckSizeChange($event)"
        formControlName="neckSize"
      ></app-height-input>

    <app-referring-doctors-select
      class="col-span-6"
      [required]="true"
      [selectedValue]="patientDetailAddInfo.value.referringDoctorId"
      (departmentSelected)="onReferringDoctorChange($event)"
    ></app-referring-doctors-select>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Shift Work Y/N</mat-label>
      <mat-select formControlName="shiftWork">
        <ng-container>
          <mat-option *ngFor="let bool of boolChoose" [value]="bool.value">
            {{ bool.viewValue }}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>

    <!-- Insurer -->
    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Insurer</mat-label>
      <input matInput formControlName="insurer" maxlength="50" />
      <mat-error
        *ngIf="patientDetailAddInfo.get('insurer')?.hasError('maxlength')"
      >
        Max 50 characters allowed
      </mat-error>
    </mat-form-field>
    <!-- Epworth Sleepiness Scale -->
    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Epworth Sleepiness Scale</mat-label>
      <input noNegativeInput matInput type="number" formControlName="epworthSleepinessScale" />
      <mat-error
        *ngIf="
          patientDetailAddInfo.get('epworthSleepinessScale')?.hasError('min')
        "
      >
        Minimum is 0
      </mat-error>
      <mat-error
        *ngIf="
          patientDetailAddInfo.get('epworthSleepinessScale')?.hasError('max')
        "
      >
        Maximum is 24
      </mat-error>
    </mat-form-field>
    <app-users-select
      label="Ordering Physician"
      class="col-span-3"
      [selectedValue]="patientDetailAddInfo.value.orderingPhysicianId"
      (userSelected)="onPhysicianUserChange($event)"
    ></app-users-select>

    <!-- A clinic patient's shipping address; a Direct patient's is on Main Information. -->
    <div class="col-span-6">
      <app-patient-shipping-address
        *ngIf="patientType !== 'DIRECT'"
        [group]="shippingGroup"
      ></app-patient-shipping-address>
    </div>
  </div>
</div>
